import { GOTO_STEP, ENABLE_BACK, ENABLE_NEXT, DISABLE_BACK, DISABLE_NEXT } from "../actions/stepper";

const INITIAL_STATE = {
  activeStepIndex: 0,
  disableBack: true,
  disableNext: false
};

export const stepperReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GOTO_STEP:
      return { ...state, activeStepIndex: action.payload };

    case DISABLE_BACK:
    return { ...state, disableBack: true };

    case DISABLE_NEXT:
    return { ...state, disableNext: true };

    case ENABLE_BACK:
    return { ...state, disableBack: false };

    case ENABLE_NEXT:
    return { ...state, disableNext: false };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/stepper.js